import type { Action } from 'redux';
import dash_api from '../../../../main/support/dash_api';
import { ReduxAsyncAction } from '../../../services/ReduxAsyncAction';

const UpdateConnection = new ReduxAsyncAction<
  'UPDATE_CONNECTION',
  { machineName: string; credentialId: string; body: any },
  { connection_name: string; credential_id: string }
>('UPDATE_CONNECTION');
UpdateConnection.registerRequest(({ machineName, credentialId, body }) => {
  return dash_api.put(`/v1/ad-network/${machineName}/connections/${credentialId}`, body).then(({ data }) => {
    return data;
  });
});
export const UPDATE_CONNECTION = UpdateConnection.actionNamespaceConstants;
export const updateConnection = UpdateConnection.request;

export type UpdateConnectionAction = Action<typeof UPDATE_CONNECTION.response | typeof UPDATE_CONNECTION.request> & {
  data: { connection_name: string; credential_id: string };
};
